"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var TokenRenderers_1 = require("./TokenRenderers");
var CommonWidgetRegistry_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgetRegistry");
var tokenRenderer = function (tokens, options) {
    var html = "";
    if (!tokens || !tokens.length) {
        return html;
    }
    var currentBlock = null;
    var innerHtml = "";
    var currentIndex = 0;
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        if (token.type == "block") {
            if (currentBlock != undefined) {
                html += renderBlock(currentBlock, currentIndex, tokens, innerHtml, options);
                innerHtml = "";
            }
            currentBlock = token;
            currentIndex = i;
        }
        else if (token.type == "inline") {
            innerHtml += renderInlineToken(token);
        }
    }
    html += renderBlock(currentBlock, currentIndex, tokens, innerHtml, options);
    return html;
};
var renderBlock = function (token, index, tokens, innerHtml, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var registryRenderedContent = (_b = (_a = (0, CommonWidgetRegistry_1.getGenericConfigByType)(token.subType)) === null || _a === void 0 ? void 0 : _a.publicRender) === null || _b === void 0 ? void 0 : _b.call(_a, token);
    if (registryRenderedContent) {
        return registryRenderedContent;
    }
    var renderer = TokenRenderers_1.tokenToCreateHtml.get(token.subType);
    if (!renderer) {
        throw new Error("Got an unknown block token subType: ".concat(token.subType));
    }
    return renderer(token, __assign(__assign({}, options), { index: index, innerHtml: innerHtml, tokens: tokens, renderTokens: tokenRenderer }));
};
var renderInlineToken = function (token) {
    var renderer = TokenRenderers_1.tokenToCreateHtml.get(token.subType);
    if (!renderer) {
        throw new Error("Got an unknown inline token subType: ".concat(token.subType));
    }
    return renderer(token, {
        renderTokens: tokenRenderer,
    });
};
exports.default = tokenRenderer;
